<template>
  <div>
    <input
      ref="fileInput"
      type="file"
      :accept="uploadFormat"
      style="display: none"
    />
    <input
      ref="imageInput"
      type="file"
      :accept="imageUploadFormat"
      style="display: none"
      @change="handleImageInputChange"
    />
    <div class="quill-box">
      <quill-editor
        id="homework-custom-quill-editor"
        ref="quill"
        class="quill-editor"
        :class="{
          'quill-editor__focus': isFocus,
          'quill-editor__position': isToolbarPosition,
          'quill-editor__position__show': isToolbarPosition && isFocus,
          'quill-editor__disabled': disabled,
        }"
        :value="value"
        :disabled="disabled"
        :options="editorOption"
        @focus="isFocus = true"
        @blur="isFocus = false"
        @input="($event) => $emit('input', $event)"
        @change="onEditorChange($event)"
      ></quill-editor>
    </div>
  </div>
</template>

<script>
import { cosUploadFile } from "@saas/components/src/utils/cos-upload";
import { UploadImage } from "@saas/components/src";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { quillEditor, Quill } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { registerAudioFeature, uploadAudio } from "./audioFeature";
import { isMobile } from "@saas/components/src";

const defaultContainer = [["image"], ["bold", "italic", "underline"]];
export default {
  components: {
    quillEditor,
    // UploadImage,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    limitLength: {
      type: Number,
      default: 0,
    },
    limitImage: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: "请输入内容",
    },
    // 图片大小限制 MB
    imageSize: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    containerList: {
      type: Array,
      default: () => [],
    },
    // 是否定位展示toolbar
    isToolbarPosition: {
      type: Boolean,
      default: false,
    },
    // 是否展示题目插入
    isShowQuestionToolbar: {
      type: Boolean,
      default: false,
    },
    // 是否展示录音 toolbar
    isShowAudioToolbar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocus: false,
      type: "image",
      showUploadImgDialog: false,
      previousContents: null, // 用于存储之前的文档内容
      editorOption: {
        placeholder: this.placeholder,
        theme: "snow",
        modules: {
          toolbar: {
            container: defaultContainer,
            handlers: {
              image: this.imgHandler,
              video: this.videoHandler,
              // singleChoice: () => {
              //   this.questionEditorHandler(1);
              // },
              // multipleChoice: () => {
              //   this.questionEditorHandler(2);
              // },
            },
          },
          clipboard: {
            matchers: [
              ["img", this.desMatcherImage],
              [
                "video",
                () => {
                  return { ops: [] };
                },
              ],
            ],
          },
        },
      },
      addRange: null,
      currentlength: 0,
      eidtorInstance: null,
      // 上传的类型 file 文件, audio 音频 , vidoe: 视频
      // uploadType: 'file',
      // 上传的文件格式
      uploadFormat: "*",
      isOverButton: false,
      imagePositionTimer: null,
      previousQuillRect: null,
      imageUploadFormat: ".jpg,.png,.gif,.jpeg,.bmp", // 图片上传格式
      limitSize: 32, //M 图片大小限制
    };
  },
  watch: {
    containerList: {
      handler(val) {
        if (val && val.length) {
          this.editorOption.modules.toolbar.container = [val];
        }
      },
      immediate: true,
    },
    isShowQuestionToolbar: {
      handler(val) {
        // if (val) {
        //   this.editorOption.modules.toolbar.container = [
        //     ['image'],
        //     ['bold', 'italic', 'underline'],
        //     // ['singleChoice', 'multipleChoice']
        //     ['singleChoice']
        //   ]
        //   this.$nextTick(() => {
        //     this.addButton()
        //   })
        // } else {
        //   this.editorOption.modules.toolbar.container = [['image'], ['bold', 'italic', 'underline']]
        // }
      },
      immediate: true,
    },
    isShowAudioToolbar: {
      handler(val) {
        if (val) {
          console.log("111>>>", val);

          this.editorOption.modules.toolbar.container = [
            ...this.editorOption.modules.toolbar.container,
            [
              // {
              //   audio: ["record"],
              // },
              "audio",
            ],
          ];
          console.log(
            this.editorOption.modules.toolbar.container,
            ">>>>container"
          );
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.isMobile = isMobile();
    if (this.$refs.quill.quill) {
      this.currentlength = this.$refs.quill.quill.getLength() - 1;
      this.previousQuillRect = this.$refs.quill.$el.getBoundingClientRect();

      this.previousContents = this.$refs.quill.quill.getContents(); // 初始化时存储文档内容
    }
    this.eidtorInstance = this.$refs.quill.quill;
    this.initToolbar();
    EventBus.$off("question-clicked", this.onClickQuestion);
    EventBus.$on("question-clicked", this.onClickQuestion);
    this.$refs.quill.quill.on("text-change", this.handleTextChange);
    this.$nextTick(() => {
      console.log(this.$refs.quill.quill, "==========888");

      registerAudioFeature(this.$refs.quill.quill, this);
      if (this.isMobile) {
        this.addDeleteBtnForImage();
      }
    });

    this.imagePositionTimer = setInterval(() => {
      const curRect = this.$refs.quill.$el.getBoundingClientRect();
      if (
        this.previousQuillRect.x !== curRect.x ||
        this.previousQuillRect.y !== curRect.y
      ) {
        this.previousQuillRect = curRect;
        this.deleteImageDeleteBug();
      }
    }, 100);
  },
  beforeDestroy() {
    this.$refs.quill.quill.off("text-change", this.handleTextChange); // 移除事件监听
    clearInterval(this.imagePositionTimer);
  },
  methods: {
    // 滚动到底部并且聚焦
    scrollToBottomFocus(val) {
      const eleEditor = document.querySelector(
        "#homework-custom-quill-editor .ql-editor"
      );
      if (!val && this.isMobile) {
        // 移动端无法输入中文问题
        this.$refs.quill.quill.insertText(this.currentlength, " ");
      }

      eleEditor.scrollTop = eleEditor.scrollHeight;
      this.$refs.quill.quill.setSelection(this.currentlength + 1);
    },
    handleFileInputChange(e) {
      if (e.target.files.length > 0) {
        try {
          const files = e.target.files[0];
          console.log(files, "=======files");
          // this.confirmSelectFile([files]);
        } catch (error) {
          console.log("handleFileInputChange", error);
        }
      }
      e.target.value = "";
    },
    // 编辑器里面的图片添加删除按钮
    addDeleteBtnForImage() {
      const qlEditor = this.$refs.quill.$el.querySelector(".ql-editor");
      console.log("qlContainer>>>>", qlEditor);
      if (qlEditor) {
        const qlContainer =
          this.$refs.quill.$el.querySelector(".ql-container>div");
        console.log("qlContainer>>>>", qlContainer);

        qlContainer.addEventListener("scroll", this.deleteImageDeleteBug);
        this.isOverButton = false;
        qlEditor.addEventListener("mouseover", (event) => {
          const qlRect = this.$refs.quill.$el.getBoundingClientRect();
          this.deleteImageDeleteBug();
          if (event.target.tagName === "IMG" && !this.disabled) {
            const img = event.target;
            const deleteButton = document.createElement("button");
            deleteButton.style.width = "24px";
            deleteButton.style.height = "24px";
            deleteButton.style.borderRadius = "15px";
            deleteButton.style.background = "#4E5969";
            deleteButton.style.color = "#fff";
            deleteButton.innerHTML = '<i class="el-icon-close"></i>';
            deleteButton.classList.add("quill-editor-delete-image-button");
            deleteButton.style.position = "fixed";
            deleteButton.style.zIndex = 99999;
            const rect = img.getBoundingClientRect();
            const deleteLeft = rect.left + img.width - 12;
            const deleteTop = rect.top - 12;
            deleteButton.style.left = deleteLeft + "px";
            deleteButton.style.top = deleteTop + "px";
            // 判断deletebutton的位置是否在qlEditor范围内
            if (
              deleteLeft > qlRect.left &&
              deleteLeft < qlRect.right &&
              deleteTop > qlRect.top &&
              deleteTop < qlRect.bottom
            ) {
              document.body.appendChild(deleteButton);
              deleteButton.addEventListener("click", () => {
                img?.remove();
                deleteButton?.remove();
              });

              deleteButton.addEventListener("mouseover", () => {
                this.isOverButton = true;
              });

              deleteButton.addEventListener("mouseout", () => {
                this.isOverButton = false;
                this.checkRemoveButton(img, deleteButton);
              });
            } else {
              deleteButton?.remove();
            }

            img.addEventListener("mouseout", () => {
              this.checkRemoveButton(img, deleteButton);
            });
          }
        });
      }
    },
    // 删除删除图片的按钮
    deleteImageDeleteBug(img, button) {
      const deletebuts = document.querySelectorAll(
        ".quill-editor-delete-image-button"
      );
      deletebuts.forEach((item) => {
        item.remove();
      });
    },
    checkRemoveButton(img, button) {
      if (!this.isOverButton) {
        const rect = img.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        const mouseX = event.clientX;
        const mouseY = event.clientY;
        if (
          !(
            rect.left <= mouseX &&
            mouseX <= rect.right &&
            rect.top <= mouseY &&
            mouseY <= rect.bottom
          ) &&
          !(
            buttonRect.left <= mouseX &&
            mouseX <= buttonRect.right &&
            buttonRect.top <= mouseY &&
            mouseY <= buttonRect.bottom
          )
        ) {
          button.remove();
        }
      }
    },
    onChangeFile(val) {
      console.log("1111.", val);
    },
    // 初始化工具栏
    initToolbar() {
      const editorDom = this.$refs.quill.$el;
      console.log("editorDom>>>>>", editorDom);

      if (editorDom) {
        if (this.isShowAudioToolbar) {
          console.log("111>>>", 3333);
          console.log(editorDom);

          const audioButton = editorDom.querySelector(".ql-audio");
          if (audioButton) {
            // const label = audioButton.querySelector(".ql-picker-label");
            audioButton.innerHTML = '<i class="saas fa-yuyin2"></i>';
          }
        }
      }
    },
    // 增加按钮
    addButton() {
      const singleChoiceButton = document.querySelector(".ql-singleChoice");
      if (singleChoiceButton) {
        singleChoiceButton.innerHTML =
          '<i class="saas fa-danxuan-xuanzhong"></i>单选';
      }
      const muliEditorButton = document.querySelector(".ql-multipleChoice");
      if (muliEditorButton) {
        muliEditorButton.innerHTML = '<i class="saas fa-shezhi"></i>多选';
      }
    },
    judgeExceedTextLimit() {
      if (this.limitLength && this.currentlength >= this.limitLength) {
        this.$showToast(`输入已达上限，无法继续输入内容`);
        return true;
      } else {
        return false;
      }
    },
    // 图片数量是否超出限制
    isLimitNum() {
      if (this.judgeExceedTextLimit()) {
        return true;
      }
      const content = this.$refs.quill.quill.getContents();
      const imageList = content.filter(
        (item) => item.insert && item.insert.image
      );
      if (this.limitImage > 0 && imageList.length >= this.limitImage) {
        this.$message.error(`图片数量不能超过${this.limitImage}张`);
        return true;
      } else {
        return false;
      }
    },
    onEditorChange({ quill, html, text }) {
      this.currentlength = this.$refs.quill.quill.getLength() - 1;
      if (this.limitLength && this.currentlength >= this.limitLength) {
        this.$refs.quill.quill.deleteText(this.limitLength, 2000000);
      }
      this.$emit("change");
      if (this.$parent?.elForm) {
        this.$parent.$emit("el.form.change");
      }
      // this.addDeleteButtonToImages()
    },
    addDeleteButtonToImages() {
      const imgs = this.$refs.quill.$el.querySelectorAll(".ql-editor img");
      console.log("img>>>>", imgs);
      imgs.forEach((img) => {
        if (!img.parentNode.classList.contains("image-wrapper")) {
          const wrapper = document.createElement("div");
          wrapper.classList.add("image-wrapper");
          const deleteButton = document.createElement("button");
          deleteButton.textContent = "删除";
          deleteButton.classList.add("delete-button");
          deleteButton.addEventListener("click", () => {
            this.deleteImage(img);
          });

          // 先保存 img 的父节点和兄弟节点
          const parent = img.parentNode;
          const nextSibling = img.nextSibling;

          // 将 img 从原父节点移除
          parent.removeChild(img);

          // 将 img 和删除按钮添加到包裹元素
          wrapper.appendChild(img);
          wrapper.appendChild(deleteButton);

          // 将包裹元素插入到原 img 的位置
          if (nextSibling) {
            parent.insertBefore(wrapper, nextSibling);
          } else {
            parent.appendChild(wrapper);
          }
        }
      });
    },
    deleteImage(img) {
      const range = this.$refs.quill.quill.getSelection(true);
      const index = this.editor.getIndex(this.$refs.quill.quill.scroll, img);
      this.editor.deleteText(index, 1);
    },
    confirmSelectFile(val) {
      if (Array.isArray(val)) {
        if (this.type === "image") {
          // 判断图片大小
          if (
            this.imageSize > 0 &&
            val[0]?.file_size &&
            val[0].file_size > this.imageSize * 1024 * 1024
          ) {
            this.$message.error("图片大小不能超过" + this.imageSize + "MB");
            return;
          }
          val.forEach((item) => {
            this.$refs.quill.quill.insertEmbed(
              this.addRange?.index,
              "image",
              item.url
            );
          });
        } else if (this.type === "video") {
          val.forEach((item) => {
            this.$refs.quill.quill.insertEmbed(
              this.addRange?.index,
              "video",
              item.url
            );
          });
        }
      }
    },
    imgHandler(val) {
      if (this.isLimitNum()) {
        return;
      }
      if (val) {
        this.$refs?.imageInput.dispatchEvent(new MouseEvent("click"));
        //   this.type = "image";
        //   this.$refs["selectFile"].showPopup(-1);
        this.addRange = this.$refs.quill.quill.getSelection();
      } else {
        this.$refs.quill.quill.format("image", false);
      }
    },
    checkFormat(file) {
      const fileType = file?.type?.split("/")?.[1] || "";
      return this.imageUploadFormat.split(",").includes("." + fileType);
    },
    checkSize(file) {
      return file.size / 1024 / 1024 <= this.limitSize;
    },
    handleImageInputChange(e) {
      if (e.target.files.length > 0) {
        try {
          const files = e.target.files[0];
          // 置空--解决重复选择同一文件时onchange不执行
          this.$refs.imageInput.value = "";
          // 校验
          if (!this.checkFormat(files)) {
            this.$message.warning(`图片格式错误`);
            return false;
          }
          if (!this.checkSize(files)) {
            this.$message.warning(`上传图片大小不能超过${this.limitSize}M!`);
            return false;
          }
          const quill = this.$refs.quill.quill;
          //上传
          uploadAudio(files, (url) => {
            console.log("data", url);
            const range = quill.getSelection();
            quill.insertEmbed(this.addRange?.index, "image", url);
            quill.setSelection(range.index + 1);
          });
        } catch (error) {
          console.log("handleImageInputChange", error);
        }
      }
    },
    videoHandler(val) {
      if (val) {
        this.type = "video";
        this.$refs["selectFile"].showPopup(-1);
        this.addRange = this.$refs.quill.quill.getSelection();
      } else {
        this.$refs.quill.quill.format("video", false);
      }
    },
    // 粘贴拦截
    desMatcherImage(node, Delta) {
      if (this.isFocus) {
        // 赋值粘贴
        Delta.ops = [];
        return Delta;
      } else {
        return Delta;
      }
    },
    // 当点击toolbar的添加题目时，触发事件
    questionEditorHandler(type) {
      const quill = this.$refs.quill.quill;
      const range = quill.getSelection(true);
      const rangeBeforeContent = quill.getContents(0, range.index);
      const num = this.getDeltaQuestion(rangeBeforeContent).length;
      quill.insertEmbed(range.index, "question", {
        index: num + 1, // 这个设置后还会重新设置index，
        uid: this._uid,
      });
      // 插入一个空格
      // quill.insertText(range.index + 1, ' ')
      this.$emit("add-question", num, type);
      this.$nextTick(() => {
        const content = quill.getContents();
        content.ops.reduce((pre, item, index) => {
          if (item.insert && item.insert.question) {
            item.insert.question.index = pre + 1;
            return pre + 1;
          } else {
            return pre;
          }
        }, 0);
        quill.setContents(content);
        quill.setSelection(range.index + 1);
      });
    },
    // 当点击输入框里面的题目
    onClickQuestion(value) {
      // if (value.uid === this._uid) {
      const questionDom =
        this.$refs.quill.$el.querySelectorAll(".question-button");
      const clickDom = value.node;
      questionDom.forEach((item) => {
        if (item === value.node) {
          clickDom.style.background = "#165DFF";
          clickDom.style.color = "#fff";
        } else {
          item.style.background = "#E8F3FF";
          item.style.color = "#165DFF";
        }
      });
      this.$emit("change-question", value.index - 1);
      // }
    },
    // 处理 text-change 事件,比较值
    handleTextChange(delta, oldDelta, source) {
      if (
        source === "user" &&
        delta.ops.length > 0 &&
        delta.ops.some((item) => item.delete)
      ) {
        this.checkForDeletedBlots(delta, oldDelta);
      }
    },
    // 检测是否有题目 被删除
    checkForDeletedBlots(delta, oldDelta) {
      const quill = this.$refs.quill.quill;
      const newDelat = quill.getContents();
      const range = quill.getSelection(true);
      const diffDelta = newDelat.diff(oldDelta);
      const deleteQuestion = this.getDeltaQuestion(diffDelta);
      if (deleteQuestion.length) {
        const deleteIndexs = [];
        deleteQuestion.forEach((item) => {
          if (item.insert?.question?.index) {
            deleteIndexs.push(item.insert.question.index - 1);
          }
        });
        this.$emit("delete-question", deleteIndexs);
        this.$nextTick(() => {
          newDelat.ops.reduce((pre, item, index) => {
            if (item.insert && item.insert.question) {
              item.insert.question.index = pre + 1;
              return pre + 1;
            } else {
              return pre;
            }
          }, 0);
          quill.setContents(newDelat);
          quill.setSelection(range.index);
        });
      }
    },
    // 获取delta中question
    getDeltaQuestion(delta) {
      if (delta.ops && delta.ops.length) {
        return delta.ops.filter((item) => item.insert && item.insert.question);
      } else {
        return [];
      }
    },
    // 主动删除某一个题目
    handleDeleteQuestion(index) {
      const quill = this.$refs.quill.quill;
      const content = quill.getContents();
      const range = quill.getSelection(true);
      content.ops = content.ops.filter((item) => {
        if (item.insert && item.insert.question) {
          return item.insert.question.index !== index + 1;
        } else {
          return true;
        }
      });
      this.$nextTick(() => {
        content.ops.reduce((pre, item, index) => {
          if (item.insert && item.insert.question) {
            item.insert.question.index = pre + 1;
            return pre + 1;
          } else {
            return pre;
          }
        }, 0);
        quill.setContents(content);
        quill.setSelection(range.index);
      });
    },
    // 手动设置问题选中样式
    setQuestionSelected(index) {
      this.$nextTick(() => {
        const quill = this.$refs.quill.$el;
        const questionButtonDom = quill.querySelectorAll(
          ".ql-container question-button"
        );
        questionButtonDom.forEach((item, qIndex) => {
          if (index === qIndex) {
            item.style.backgroundColor = "#165dff";
            item.style.color = "#fff";
          } else {
            item.style.backgroundColor = "#e8f3ff";
            item.style.color = "#165DFF";
          }
        });
      });
    },
    // 插入音频
    handleAudioContent(url) {
      const quill = this.$refs.quill.quill;
      const range = quill.getSelection(true);
      if (range) {
        quill.insertEmbed(range.index, "audio", url);
        quill.setSelection(range.index + 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.quill-box {
  position: relative;
  .limit-text {
    width: calc(100% - 2px);
    background: #fff;
    text-align: right;
    position: absolute;
    right: 1px;
    bottom: 1px;
    padding-right: 20px;
    color: #97a8be;
  }
}
.quill-editor ::v-deep {
  border: none;
  border-radius: 8px;
  .ql-toolbar.ql-snow {
    padding: 0 3px;
    border-color: #e5e6eb;
    border-radius: 8px 8px 0 0;
    background: #fff;
    border: none;
    margin: 3px 7px;
    // border: 1px solid #e5e6eb;
    // border-radius: 8px;
    min-height: 34px;
    line-height: 34px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    .ql-formats {
      margin: 0;
      button {
        padding: 3px 3px;
      }
      .ql-picker-options {
        border-radius: 5px;
        border-color: #e5e6eb;
      }
    }
    .ql-picker-label {
      position: relative;
      border: none;
      &::before {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .ql-multipleChoice,
    .ql-singleChoice {
      padding: 0;
      width: auto;
      font-size: 14px;
      color: #1d2129;
      display: inline-block;
      display: flex;
      align-items: center;
      i {
        margin-right: 4px;
      }
    }
    .ql-singleChoice {
      width: 59px;
      height: 24px;
      margin-left: 8px;
      margin-right: 10px;
      background: #f7f8fa;
      border-radius: 6px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        width: 1px;
        height: 24px;
        background: #f2f3f5;
        transform: translateY(-50%);
        left: -9px;
      }
    }
    .ql-audio {
      display: flex;
      align-items: center;
      i {
        font-size: 22px;
      }
    }
    .ql-audio.ql-picker {
      .ql-picker-label {
        // width: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 24px;
        }
      }
      .ql-picker-options {
        .ql-picker-item {
          &:first-child {
            &::before {
              content: "上传";
            }
          }
          &:last-child {
            &::before {
              content: "录音";
            }
          }
        }
      }

      // .ql-picker-label {
      //   &::before {
      //     content: '测试';
      //   }
      // }
    }
  }
  .ql-container.ql-snow {
    // 设置高度-文本区域可以滚动
    // min-height: 200px;
    height: 330px;
    overflow: auto;
    margin-bottom: 12px;
    // padding-bottom: 40px;
    padding: 0;
    background: #fff;
    border-color: #e5e6eb;
    border-radius: 0 0 16px 16px;
    font-size: 14px;
    color: var(--el-text-color-primary);
    border: none;
    .ql-editor {
      padding: 7px 12px;
      word-break: break-word !important;
      .image-wrapper {
        position: relative;
        display: inline-block;
        .delete-button {
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }
    .ql-editor.ql-blank {
      font-size: 14px;
      color: #86909c;
      font-style: normal;
      line-height: 22px;
      &::before {
        font-style: normal;
      }
    }
    span:has(> question-button) {
      // display: inli;
      height: 20px;
      width: 44px;
      background: unset !important;
    }
  }
  .limit-text {
    border-radius: 0 0 8px 8px;
  }
}
.quill-editor__position ::v-deep {
  .ql-toolbar.ql-snow {
    display: none;
    height: 33px;
    line-height: 33px;
    position: absolute;
    left: 0;
    z-index: 999;
    top: -35px;
    box-shadow: 2px 4px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px !important;
    border: 1px solid #f2f3f5;
    margin: 0;
  }
  .ql-container.ql-snow {
    min-height: 36px;
    max-height: 225px;
    border-radius: 6px !important;
    // border: 1px solid #e5e6eb;
    padding-bottom: 0;
    .ql-editor {
      padding: 7px 12px;
      min-height: 36px;
      word-break: break-word !important;
      line-height: 22px;
    }
  }
}
.quill-editor__position__show ::v-deep {
  .ql-toolbar.ql-snow {
    display: block;
  }
}
.quill-editor__disabled ::v-deep {
  .ql-toolbar.ql-snow {
    display: none;
  }
  .ql-container.ql-snow {
    border-radius: 6px !important;
    // border: 1px solid #e5e6eb;
  }
}
.quill-editor__focus ::v-deep {
  border-color: var(--theme-color);
  .ql-container.ql-snow {
  }
}
</style>
